import { render, staticRenderFns } from "./ASnippetCategory.vue?vue&type=template&id=80a6366a&scoped=true&"
import script from "./ASnippetCategory.vue?vue&type=script&lang=ts&"
export * from "./ASnippetCategory.vue?vue&type=script&lang=ts&"
import style0 from "./ASnippetCategory.vue?vue&type=style&index=0&id=80a6366a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80a6366a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VChip,VIcon})
